import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StaffEventTypeAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-staff-event-type-audit-list',
  templateUrl: './staff-event-type-audit-list.component.html',
  styleUrls: ['./staff-event-type-audit-list.component.scss']
})
export class StaffEventTypeAuditListComponent implements OnInit {
  @Input() staffEventTypeId: number;
  @Input() loading: boolean;
  @Input() staffEventTypeAudits: StaffEventTypeAudit[];

  @Output() loadStaffEventType = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadStaffEventType.emit(this.staffEventTypeId);
  }

  onNextPage() {
    this.nextPage.emit(this.staffEventTypeId);
  }
}
